/* eslint-disable @typescript-eslint/naming-convention */
import SHARED_ROUTES from 'shared/routes';

export enum MARKETING_ROUTES {
  ABOUT = 'https://dutchie.com/business/about',
  BLOG = 'https://dutchie.com/business/blog',
  BLOG_CATEGORY = 'https://dutchie.com/business/blog/category',
  BLOG_CATEGORY_SLUG = 'https://dutchie.com/business/blog/[category]/[slug]',
  BLOG_SEARCH = 'https://dutchie.com/business/blog/search',
  CAREERS = 'https://dutchie.com/business/careers',

  DISPENSARY_B2B = 'https://dutchie.com/business',
  DISPENSARY_ECOMMERCE = 'https://dutchie.com/business/ecommerce',
  DISPENSARY_FEATURES = 'https://dutchie.com/business/features',
  DISPENSARY_INTEGRATIONS = 'https://dutchie.com/business/integrations',
  DISPENSARY_PAYMENTS = 'https://dutchie.com/business/payments',
  DISPENSARY_POINT_OF_SALE = 'https://dutchie.com/business/pos',
  INTEGRATIONS = 'https://dutchie.com/business/integrations',

  MULTIPLE_LOCATIONS = 'https://dutchie.com/business/multiple-locations',
  MULTIPLE_STATE_OPERATOR = 'https://dutchie.com/business/mso',

  PLUS = '/plus',
  PLUS_DEMO = '/plus/demo',
  PLUS_DOCS = '/dutchie-plus/',

  VERTICALLY_INTEGRAGED = 'https://dutchie.com/business/vertically-integrated',
  SINGLE_DISPENSARY = 'https://dutchie.com/business/single-dispensary',

  DUTCHIE_PAY_SIGNUP = '/pay/signup',
}

export enum SHOPPING_ROUTES {
  BROWSE = '/browse',
  CATEGORIES = '/categories',
  CITY = '/city',
  CITY_CITY_KEY = '/city/[city]',
  COUNTRY_STATE_CITY = '/[countryCode]/dispensaries/[stateCodeAndCityName]',
  DISPENSARIES = '/dispensaries',
  DISPENSARY_CNAME = '/dispensary/[cName]',
  STORES_PRODUCT_REVIEW = '/stores/[cName]/product-review',
  LOCATIONS = '/locations',
  PRODUCTS_CATEGORY = '/products/[category]',
  SPECIAL_ID = '/[specialId]',
  SHOP = '/shop',
  SHOP_DISPENSARY = '/shop/dispensary',
  SHOP_PRODUCTS = '/shop/products',
  SHOP_PRODUCTS_CATEGORY = '/shop/products/[category]',
}

export enum USER_ROUTES {
  ACCOUNT = '/account',
  BANK_ACCOUNT = '/account/bank-account',
  MESSAGING = '/messaging/[cName]/[orderId]/[token]',
  ORDER = '/account/orders/[orderId]',
  ORDERS = '/account/orders',
  USER = '/user',
  USER_LOYALTY = '/user/loyalty',
  OAUTH_AUTO_LOGIN = '/oauth/auto-login',
  USER_ACCOUNT = '/user/account',
  USER_ORDERS = '/user/orders',
  USER_PREFERENCES = '/user/preferences',
}

export enum LEGAL_ROUTES {
  ACCESSIBILITY = '/accessibility',
  DISPOTERMS = '/dispensary-terms',
  TERMS = '/terms',
}

export enum MARKETPLACE_ROUTES {
  NEWS = '/news',

  HOME = '/',

  PREFERENCES = `/account/preferences`,

  PRIVACY = '/privacy',

  ROOT = '/',
  WHOOPS = '/whoops',
}

const routes: Record<string, string> = {
  ...SHARED_ROUTES,
  ...MARKETING_ROUTES,
  ...SHOPPING_ROUTES,
  ...USER_ROUTES,
  ...LEGAL_ROUTES,
  ...MARKETPLACE_ROUTES,
};

export default routes;
